import React from 'react';
import Icon from '../../../components/AppIcon';

const CultureTimeline = ({ events }) => {
  return (
    <div className="relative">
      <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />
      <div className="space-y-8">
        {events?.map((event, index) => (
          <div key={index} className="relative pl-16">
            <div className="absolute left-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center border-4 border-background">
              <Icon name={event?.icon} size={20} color="var(--color-primary)" strokeWidth={2.5} />
            </div>
            <div className="bg-card border border-border rounded-lg p-5 hover:shadow-elevation-1 transition-all duration-200">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-lg font-bold text-foreground">{event?.title}</h4>
                <span className="text-xs text-muted-foreground bg-muted/30 px-3 py-1 rounded-full">
                  {event?.date}
                </span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{event?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CultureTimeline;